module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticClass: "back-wall-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/bgimg.png"),
      "alt": "back-wall"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAlert),
      expression: "!showAlert"
    }],
    staticClass: "progress-wrap-bg"
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "45%",
      "left": "50%",
      "transform": "translate(-50%,-50%)"
    },
    attrs: {
      "mode": "determinate",
      "strokeWidth": 8,
      "color": "#EAF4FF",
      "size": 180,
      "value": 100
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAlert),
      expression: "!showAlert"
    }],
    staticClass: "progress-wrap-cogn"
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "45%",
      "left": "50%",
      "transform": "translate(-50%,-50%)"
    },
    attrs: {
      "mode": "determinate",
      "strokeWidth": 8,
      "color": "#0A81E5",
      "size": 180,
      "value": _vm.precent
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAlert),
      expression: "!showAlert"
    }],
    staticClass: "progress-wrap-lan"
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "45%",
      "left": "50%",
      "transform": "translate(-50%,-50%)"
    },
    attrs: {
      "mode": "determinate",
      "strokeWidth": 8,
      "color": "#0A81E5",
      "size": 180,
      "value": _vm.lanPercent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "medicine-wrap"
  }, [(_vm.showMedicine) ? _c('img', {
    staticClass: "medicine",
    attrs: {
      "id": "medicine-pic",
      "src": require("../../assets/img/medicine.png"),
      "alt": "medicine"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showMedicine) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/medicine_down.png"),
      "alt": "medicine_down"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "width": "320px",
      "transform": "translateX(-50%)",
      "color": "#999999",
      "text-align": "center",
      "top": "40px"
    }
  }, [_vm._v("读取资源失败，可能因为您的网络不稳定，"), _c('br'), _vm._v("请点击“退出”后重试")]), _vm._v(" "), (_vm.showCognPrecent) ? _c('div', {
    staticClass: "precent"
  }, [_vm._v(_vm._s(_vm.precent + "%"))]) : _vm._e(), _vm._v(" "), (!_vm.showCognPrecent) ? _c('div', {
    staticClass: "precent"
  }, [_vm._v(_vm._s(_vm.lanPercent + "%"))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [_vm._v("努力为您加载中，请耐心等候一下哦...")]), _vm._v(" "), _c('div', {
    staticClass: "cancel-wrap"
  }, [_c('button', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("退出")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2575b571!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = 964
// module chunks = 2